import { getEnvironmentConfig, cockpitDataProvider } from "@airborne/react-admin";
import * as config from "./config";

const SaveFile = (file: File, props) => {
  const envConfig = getEnvironmentConfig(config);
  const dataProvider = cockpitDataProvider(envConfig.apiBaseUrl);
  const { http } = dataProvider;

  const uploadFile = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append("file", file);
    const {
      data: { objectKey },
    } = await http.post(dataProvider.baseUrl + "/minio", formData);

    return objectKey;
  };

  const postFile = async (item): Promise<any> => {
    return await http.post(dataProvider.baseUrl + "/" + props.source, item);
  };

  return uploadFile(file).then((objectKey: string) => {
    const createFile = { id: 0, name: file.name, objectKey: objectKey };
    props.object["file"] = createFile;
    return postFile(props.object).then();
  });
};

export default SaveFile;
